












import { defineComponent } from "@vue/composition-api";
import { Group, InputGroupCreate } from "@scrile/api-provider/dist/api/GroupsProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import { FormField } from "@/types";
import BasePromptConfirmation from "@/components/BasePromptConfirmation";

export default defineComponent({
  name: "CreateGroupModal",
  components: { BasePromptConfirmation },
  props: {
    show: { type: Boolean, required: true },
    group: { type: Object as () => Group, default: null },
  },
  setup() {
    const { authUserStrict } = useAuthUser();
    return { authUserStrict };
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    inputProps(): Partial<FormField> {
      return {
        value: this.group ? this.group.name : "",
        placeholder: $t("My new list"),
        autofocus: true,
        rules: ["required"],
        validationMode: "aggressiveNotBlur",
      };
    },
    title(): string {
      return this.group ? "Rename list" : "Create new list";
    },
  },
  methods: {
    async createGroup(groupName: string, clearInput: Function) {
      if (this.loading) {
        return;
      }
      const data: InputGroupCreate = {
        ownerId: this.authUserStrict.id,
        name: groupName,
        memberIds: [],
      };
      try {
        this.loading = true;
        const createdGroup = await providers.GroupsProvider.create({ data });
        clearInput();
        this.$emit("create", createdGroup);
        this.$emit("close");
      } finally {
        this.loading = false;
      }
    },
    async renameGroup(groupName: string) {
      if (this.loading) {
        return;
      }
      try {
        this.loading = true;
        await providers.GroupsProvider.update({
          data: {
            id: this.group.id,
            name: groupName,
          },
        });
        this.$emit("rename");
        this.$emit("close");
      } finally {
        this.loading = false;
      }
    },
    submit(groupName: string, clearInput: Function) {
      return this.group ? this.renameGroup(groupName) : this.createGroup(groupName, clearInput);
    },
  },
});
